import Button from '@mui/material/Button';
import React from 'react';
import Tooltip from 'src/components/Layouts/Tooltip';
import { isCypress } from '../../../utils/useCypress';
import { mergeProps, useLongPress } from 'react-aria';
import useStyles from './style';

type NormalButtonType = {
  type?: 'button' | 'submit' | 'reset';
  buttonType?: 'primary' | 'primaryOutlined' | 'secondary' | 'tertiary' | 'chip' | 'brand' | 'clear' | 'filter' | 'blue' | 'darkBlue' | 'darkBlueOutlined' | 'red' | 'yellow' | 'white' | 'black' | 'blackOutlined' | 'disabled' | 'reacted' | 'text' | 'saved';
  className?: any;
  startIcon?: any;
  onClick?: any;
  onLongPress?: any;
  onMouseEnter?: any;
  onMouseLeave?: any;
  children?: any;
  disabled?: boolean;
  useDisabledStyle?: boolean;
  disableRipple?: boolean;
  tabIndex?: any;
  tooltip?: any;
  tooltipPosition?: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top';
  tooltipArrow?: boolean;
  tooltipMaxWidth?: any;
  dataCy?: string;
  customRef?: any;
  dataClarityMask?: 'true' | 'false';
  dataClarityUnmask?: 'true' | 'false';
};

const NormalButton: React.FunctionComponent<NormalButtonType> = ({type, buttonType = "primary", className, startIcon, onClick, onLongPress, onMouseEnter, onMouseLeave, children, disabled, useDisabledStyle = true, disableRipple, tabIndex = 0, tooltip, tooltipPosition = "right", tooltipArrow = true, tooltipMaxWidth = '100', dataCy, customRef, dataClarityMask, dataClarityUnmask}) => {

  if(buttonType === "disabled") disabled = true;
  if(disabled && useDisabledStyle) buttonType = "disabled";
  
  const classes = useStyles({
    buttonType,
    maxWidth: tooltipMaxWidth,
  });

  const { longPressProps } = useLongPress({
    onLongPress: (e: any) => {
      if(onLongPress) {
        onLongPress(e);
      }
    }
  });

  const handleOnClick = (e: any) => {
    if(onLongPress) {
      e.stopPropagation();
      e.preventDefault();
    }
    if(onClick) onClick(e);
  };

  const handleOnMouseEnter = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if(onMouseEnter) onMouseEnter(e);
  };

  const handleOnMouseLeave = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if(onMouseLeave) onMouseLeave(e);
  };
  
  return (
    <>
      {
        (tooltip && !disabled) ? (
          <Tooltip title={tooltip} className={classes.tooltipWidth} position={tooltipPosition} arrow={tooltipArrow}>
            <Button {...mergeProps(onLongPress ? longPressProps : null)} type={type} startIcon={buttonType === 'text' ? '' : startIcon} className={`${classes.normalButton} ${className}`} onClick={handleOnClick} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave} disabled={disabled} disableFocusRipple={disableRipple} disableTouchRipple={disableRipple} tabIndex={parseInt(tabIndex)} data-cy={isCypress() ? dataCy : null} disableRipple={buttonType === 'text'} ref={customRef} data-clarity-mask={dataClarityMask} data-clarity-unmask={dataClarityUnmask}>
              <span>{children}</span>
            </Button>
          </Tooltip>
        ) : (
          <Button {...mergeProps(onLongPress ? longPressProps : null)} type={type} startIcon={buttonType === 'text' ? '' : startIcon} className={`${classes.normalButton} ${className}`} onClick={handleOnClick} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave} disabled={disabled} disableFocusRipple={disableRipple} disableTouchRipple={disableRipple} tabIndex={parseInt(tabIndex)} data-cy={isCypress() ? dataCy : null} disableRipple={buttonType === 'text'} ref={customRef} data-clarity-mask={dataClarityMask} data-clarity-unmask={dataClarityUnmask}>
            <span>{children}</span>
          </Button>
        )
      }
    </>
  )
};

export default NormalButton;